import { useMutation } from '@tanstack/react-query';

import { FilesApi } from '../files.api';

// TODO rename
export const useImageUpload = () => {
  return useMutation({
    mutationFn: FilesApi.uploadFile,
  });
};
